export const parseDurationMinutes = (value) => {
  if (value == null) return 0;
  if (typeof value === "number" && Number.isFinite(value)) {
    return Math.max(0, Math.floor(value));
  }

  const text = String(value).toLowerCase();
  let hours = 0;
  let minutes = 0;

  const hourMatches = text.matchAll(/(\d+)\s*(hours?|hrs?|h)\b/g);
  for (const match of hourMatches) {
    hours += Number(match[1] || 0);
  }

  const minuteMatches = text.matchAll(/(\d+)\s*(minutes?|mins?|m)\b/g);
  for (const match of minuteMatches) {
    minutes += Number(match[1] || 0);
  }

  const total = hours * 60 + minutes;
  if (total > 0) return total;

  const fallback = text.match(/(\d+)/);
  return fallback ? Number(fallback[1]) : 0;
};

